import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DownloadChecksum from "../components/product/DownloadChecksum";
import { api } from "../services/api";

export default function DownloadPage() {
  const { versionId } = useParams();
  const navigate = useNavigate();
  const request = useRef(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [metadata, setMetadata] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    setMetadata(null);
    // Reuse the start request across Strict Mode effect replays.
    if (request.current?.versionId !== versionId) {
      request.current = {
        versionId,
        launched: false,
        promise: api.post("/downloads/start", { versionId }),
      };
    }
    const current = request.current;
    current.promise
      .then(({ data }) => {
        if (cancelled) return;
        if (!data.downloadUrl) throw new Error("Invalid download URL received");
        if (!current.launched) {
          current.launched = true;
          const link = document.createElement("a");
          link.href = data.downloadUrl;
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
        setMetadata(
          data.checksum_status === "ready" && data.sha256 ? data : null,
        );
        setLoading(false);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err.response?.data?.message ||
              err.message ||
              "Failed to start download",
          );
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [versionId, navigate]);
  return (
    <Box
      sx={{
        p: 3,
        maxWidth: 850,
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ mt: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
          Back to Product
        </Button>
      </Box>

      <Typography variant="h5" gutterBottom>
        {metadata
          ? "Download verification"
          : loading
            ? "Starting download"
            : "Download"}
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Alert severity="success">
          Your download has been started. Check your browser’s download
          progress.
        </Alert>
      )}
      {!error && metadata && (
        <DownloadChecksum
          key={versionId}
          versionId={versionId}
          initiallyExpanded
          initialMetadata={metadata}
        />
      )}
    </Box>
  );
}
